module.exports = __webpack_public_path__ + "img/pdfRel.3f1da9ff.svg";